import { render } from "./rooming_lists.vue?vue&type=template&id=3f93caa1"
import script from "./rooming_lists.vue?vue&type=script&lang=js"
export * from "./rooming_lists.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__